import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Spin } from "antd";

import MaterialRequestContractBlock from "./MaterialRequestContractBlock/MaterialRequestContractBlock";
import MaterialRequestMaterialsBlock from "./MaterialRequestMaterialsBlock/MaterialRequestMaterialsBlock";
import { useMaterialRequest } from "../../../hooks/useMaterialRequest";
import {
  buildMaterialRequestPayload,
  getEnabledMaterialBoxes,
  hasAnyEnabledMaterialBoxQtyGreaterThanZero,
  materialRequestMaterialsFields,
  shouldShowDeferredProcessingNotice,
} from "../../../utils/materialRequestUtils";
import MaterialRequestLoadingModal from "../../Modals/MaterialRequestLoadingModal/MaterialRequestLoadingModal";

function MaterialRequestForm({ form, reduxUserProfiles }) {
  const { validateFieldsAndScroll } = form;
  const {
    materialLimit,
    fetchMaterialLimit,
    resetMaterialLimit,
    createMaterialRequest,
  } = useMaterialRequest();

  const [showBoxesError, setShowBoxesError] = useState(false);
  const [isCreatingMaterialRequest, setIsCreatingMaterialRequest] =
    useState(false);

  const hasMaterialLimitLoaded = materialLimit.status === "loaded";

  const hasEnabledMaterialBoxes =
    hasMaterialLimitLoaded && getEnabledMaterialBoxes(materialLimit).length > 0;

  const hasMaterialLimitWithoutBoxes =
    hasMaterialLimitLoaded && !hasEnabledMaterialBoxes;

  const handleContractCompleted = async (data) => {
    setShowBoxesError(false);

    await fetchMaterialLimit(
      data.contractNumber,
      data.clientNumber,
      data.labellerCode,
    );
  };

  const handleFullFormReset = () => {
    resetMaterialLimit();
    setShowBoxesError(false);
    form.resetFields();
  };

  const handleContractReset = () => {
    form.resetFields(Object.keys(materialRequestMaterialsFields));
    resetMaterialLimit();
    setShowBoxesError(false);
  };

  const hasAnyBoxQtyGreaterThanZero = (values) =>
    hasAnyEnabledMaterialBoxQtyGreaterThanZero(values, materialLimit);

  const handleMaterialFormChange = () => {
    setTimeout(() => {
      const values = form.getFieldsValue();

      if (hasAnyBoxQtyGreaterThanZero(values)) {
        setShowBoxesError(false);
      }
    }, 0);
  };

  const submitMaterialRequest = (formData) => {
    createMaterialRequest(
      formData,
      handleFullFormReset,
      () => setIsCreatingMaterialRequest(true),
      () => setIsCreatingMaterialRequest(false),
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    validateFieldsAndScroll((error, values) => {
      const hasValidBoxQty = hasAnyBoxQtyGreaterThanZero(values);

      setShowBoxesError(!hasValidBoxQty);

      if (error || !hasValidBoxQty) return;

      const formData = buildMaterialRequestPayload(values, materialLimit);

      if (!shouldShowDeferredProcessingNotice()) {
        submitMaterialRequest(formData);
        return;
      }

      Modal.warning({
        content:
          "Se va a tramitar su petición, aunque al superar la hora de solicitud las 13:30 horas es posible que no pueda ser atendido hasta el siguiente día hábil.",
        okText: "Aceptar",
        centered: true,
        width: 600,
        onOk() {
          submitMaterialRequest(formData);
        },
      });
    });
  };

  return (
    <div className="MaterialRequestForm">
      {isCreatingMaterialRequest && <MaterialRequestLoadingModal />}

      <Form onSubmit={handleSubmit}>
        <MaterialRequestContractBlock
          form={form}
          reduxUserProfiles={reduxUserProfiles}
          onContractCompleted={handleContractCompleted}
          onContractReset={handleContractReset}
        />

        {materialLimit.isLoading && (
          <div className="material-request-feedback">
            <Spin />
            <span>Consultando contrato...</span>
          </div>
        )}

        <MaterialRequestMaterialsBlock
          form={form}
          materialLimit={materialLimit}
          onMaterialFormChange={handleMaterialFormChange}
          showBoxesError={showBoxesError}
        />

        {hasMaterialLimitWithoutBoxes && (
          <div className="material-request-no-boxes-message">
            <h2>
              El contrato seleccionado no tiene autorización para realizar
              peticiones de material.
            </h2>
            <h2>
              Por favor, póngase en contacto con su comercial de la
              cuenta/operaciones de Correos Frio.
            </h2>
          </div>
        )}

        {hasEnabledMaterialBoxes && (
          <div className="material-request-submit-container">
            <Button htmlType="submit" className="submit-btn" disabled={false}>
              Confirmar
            </Button>
          </div>
        )}
      </Form>
    </div>
  );
}

export default Form.create()(MaterialRequestForm);
